import { cn } from "@/shared/utils";
import IconClose from "@/assets/icons/close.svg?react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from "../ui/dialog";

interface DonDialogProps {
  trigger: React.ReactNode;
  isOpen: boolean;
  onOpenChange: (value: boolean) => void;
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  titleClassName?: string;
  children?: React.ReactNode;
  descriptionClassName?: string;
  footer?: React.ReactNode;
}

const DonDialog = (props: DonDialogProps) => {
  const {
    trigger,
    isOpen,
    onOpenChange,
    title,
    description,
    titleClassName,
    descriptionClassName,
    footer,
    children,
  } = props;

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>

      <DialogContent className="bg-red p-4 bg-gray-linear rounded-20 max-w-[85vw] after:pointer-events-none after:z-0 after:absolute after:inset-0 after:border-2 after:border-white/08 after:rounded-20 border-none">
        <DialogClose className="absolute right-4 top-4 bg-white/08 rounded-full p-1.5">
          <IconClose />
        </DialogClose>

        <img
          className="absolute left-1/2 -translate-x-1/2 top-0 -translate-y-1/2 w-[200px] aspect-square pointer-events-none z-10"
          src="images/patterns/check-in-modal.webp"
          alt=""
        />

        <div className="relative z-10 gap-4 flex flex-col items-center mt-10">
          <div>
            {typeof title === "string" ? (
              <DialogTitle
                className={cn(
                  "flex-center text-[22px] gap-1 text-center text-white leading-130 font-bold self-stretch mb-2",
                  titleClassName
                )}
              >
                {title}
              </DialogTitle>
            ) : (
              title
            )}

            {description &&
              (typeof description === "string" ? (
                <p
                  className={cn(
                    "text-center text-sm text-white/80 font-normal leading-130",
                    descriptionClassName
                  )}
                >
                  {description}
                </p>
              ) : (
                description
              ))}
          </div>
          {children}

          {footer}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DonDialog;
